module.exports = __webpack_public_path__ + "media/landing_page/lp4-hero-mobile-02-21df89fd.webp";